export enum usersPermissionsActions {
    UPDATE_USERS_PERMISSIONS_TABLE_STATE = '[USERS_PERMISSIONS] UPDATE_AUDIENCES_TABLE_STATE',
    SET_SEARCH_TERM = '[USERS_PERMISSIONS] SET_SEARCH_TERM',
    RESET = '[USERS_PERMISSIONS] RESET'
}
